import React, { FC } from 'react';
import styled from 'styled-components';

const StyledTitle = styled.h1<{ $as: "h1" | "h2" }>`
  margin: 0;
  font-weight: bold;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  color: ${({ theme }) => theme.palette.text};
  font-size: ${({ theme }) => theme.fontSize.h1};
  line-height: ${({ theme }) => theme.spacing.xLarge};
  max-width: 95%;

    font-size: ${({ theme, $as }) => {
    switch ($as) {
      case "h2":
        return theme.fontSize.h2;
      default:
        return theme.fontSize.h1;
    }
  }};

  @media (max-width: 800px) {
    font-size: ${({ theme }) => theme.fontSize.h2};
  }
`;

interface NgPageTitleProps {
  title: string;
  secondary?: boolean
}

export const NgPageTitle: FC<NgPageTitleProps> = ({ title, secondary }) => <StyledTitle $as={secondary ? 'h2' : 'h1'}>{title}</StyledTitle>;
